import * as React from 'react';
import { CustomSubmitButton, CustomButton, ButtonType, Modal, ModalBody, ModalFooter, ModalSize, Textarea, Form } from 'soprasteria-ui-library';
import { useAuth } from '../../../../App';
import { OrthodonticReferralDecisionApi } from '../../../../api/OrthodonticReferralDecisionApi';
import { IOrthodonticReferralAdvancedConsultationNeedComment } from '../../../../models/IOrthodonticReferral';

interface IOrthodonticReferralAdvancedConsultationNeedCommentModal {
    getOrthodonticReferral: (orthodonticReferralId: number, refresh: boolean) => void;
    orthodonticReferralId: number;
    changeSuccessMessage: (message: string) => void;
    renderForm: boolean;
    setRenderForm: React.Dispatch<React.SetStateAction<boolean>>;
    orthodonticReferralAdvancedConsultationNeedId: number;
    selectedOrthodonticReferralAdvancedConsultationNeedComment?: IOrthodonticReferralAdvancedConsultationNeedComment;
    changeSelectedOrthodonticReferralAdvancedConsultationNeedComment: () => void;
}

export const OrthodonticReferralAdvancedConsultationNeedCommentModal: React.FunctionComponent<IOrthodonticReferralAdvancedConsultationNeedCommentModal> = ({ getOrthodonticReferral, orthodonticReferralId, changeSuccessMessage, setRenderForm, renderForm, orthodonticReferralAdvancedConsultationNeedId, changeSelectedOrthodonticReferralAdvancedConsultationNeedComment, selectedOrthodonticReferralAdvancedConsultationNeedComment }) => {

    const auth = useAuth();
    const api = new OrthodonticReferralDecisionApi(auth);
    const [isSavingComment, setIsSavingComment] = React.useState<boolean>();

    const saveOrthodonticReferralAdvancedConsultationNeedComment = (data: IOrthodonticReferralAdvancedConsultationNeedComment) => {
        setIsSavingComment(true);

        data.orthodonticReferralAdvancedConsultationNeedId = orthodonticReferralAdvancedConsultationNeedId;
        if (selectedOrthodonticReferralAdvancedConsultationNeedComment !== undefined) {
            data.orthodonticReferralAdvancedConsultationNeedCommentId = selectedOrthodonticReferralAdvancedConsultationNeedComment.orthodonticReferralAdvancedConsultationNeedCommentId;
        }
        api.saveOrthodonticReferralAdvancedConsultationNeedComment(data, () => {
            changeSuccessMessage("Kommentaren har sparats");
            document.getElementById("close-add-orthodontic-referral-advanced-consultation-need-comment-modal")?.click();
            getOrthodonticReferral(orthodonticReferralId, true);
        }, undefined, () => setIsSavingComment(false));
    }

    return (
        <Modal id="add-orthodontic-referral-advanced-consultation-need-comment-modal" header="Lägg till en kommentar" modalSize={ModalSize.large}>
            {
                renderForm ?
                    <Form onSubmit={saveOrthodonticReferralAdvancedConsultationNeedComment}>
                        <ModalBody>
                            <Textarea name="comment" label="Kommentar" defaultValue={selectedOrthodonticReferralAdvancedConsultationNeedComment?.comment} required inlineLabel rows={8} />
                        </ModalBody>
                        <ModalFooter>
                            <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-add-orthodontic-referral-advanced-consultation-need-comment-modal"
                                onClick={() => {
                                    setRenderForm(false);
                                    changeSelectedOrthodonticReferralAdvancedConsultationNeedComment();
                                }} />
                            <CustomSubmitButton isLoading={isSavingComment}>Spara</CustomSubmitButton>
                        </ModalFooter>
                    </Form>
                    : null
            }
        </Modal>
    )
}